var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Ride"},[_c('div',{class:( _obj = {
      'ride-container': true,
      flipped: _vm.flipped
    }, _obj[_vm.selectedRide.id] = true, _obj )},[(_vm.$store.state.rides.inAltState && _vm.selectedRide.imgAlt)?_c('img',{staticClass:"ride ride-alt",style:({
        transform: 'scaleX(' + (_vm.flipped ? 1 : -1) * _vm.direction + ')'
      }),attrs:{"src":_vm.selectedRide.imgAlt},on:{"click":function($event){return _vm.$store.dispatch('toggleRideInAltState')}}}):_c('img',{staticClass:"ride",style:({
        transform: 'scaleX(' + (_vm.flipped ? 1 : -1) * _vm.direction + ')',
        'transform-origin': '50% 70%'
      }),attrs:{"src":_vm.selectedRide.img},on:{"click":function($event){return _vm.$store.dispatch('toggleRideInAltState')}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }